import React from 'react';
import './main.css';
import t from '../i8n';

export default
class Footer extends React.Component {
	render(){
		return (
			<div className="footer">
				<div className="footer-wrap">
					<p>Karol Walasek &copy; {new Date().getFullYear()}</p>
					<p>{t({
						pl: 'Ta strona nie przetwarza żadnych danych osobowych, ani nie wykorzystuje ciastek.',
						en: 'This website does not process any personal data, nor does it use cookies.'
					})}</p>
					<p>{t({
						pl: 'Fajnie, co? :)',
						en: 'Pretty cool, huh? :)'
					})}</p>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Footer/index.js